import { render } from "./DeleteReport.vue?vue&type=template&id=3983b9d2&scoped=true"
import script from "./DeleteReport.vue?vue&type=script&lang=js"
export * from "./DeleteReport.vue?vue&type=script&lang=js"

import "./DeleteReport.vue?vue&type=style&index=0&id=3983b9d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3983b9d2"]])

export default __exports__